import React from 'react';
import { connect } from 'react-redux';
import { Upload, Modal, message } from 'antd';
import { Icon, Button } from 'antd';
import { Select } from 'antd';
import {
    uploadDocument,
    getDocuments,
    removeDocument,
} from '../services';

const { Option } = Select;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class DocumentsScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            documentType: '',
            fileList: [],
        };
    }

    componentDidMount() {
        this.fetchDocs();
    }

    fetchDocs = () => {
        const { doctorId, centerId } = this.props;
        getDocuments(doctorId, centerId)
            .then((response) => {
                const fileList = response.documents.map((d) => {
                    return {
                        uid: d.documentId,
                        name: d.type,
                        status: 'done',
                        url: d.link,
                    };
                });
                this.setState({
                    fileList: fileList || [],
                });
            });
    };

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = (file) => {
        let promise = Promise.resolve();
        if (!file.url && !file.preview) {
            promise = getBase64(file.originFileObj);
        }
        return promise
            .then((preview) => {
                console.log(file, 'handlePreview');
                file.preview = preview;
                this.setState({
                    previewImage: file.url || file.preview,
                    previewVisible: true,
                    previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
                });
            });
    };

    handleChange = ({ fileList }) => {
        console.log(fileList, "on change");
        this.setState({ fileList });
    };

    handleRemove = (response) => {
        console.log(response, 'On Remove');
        return removeDocument(response.uid);
    };

    handleUpload = (response) => {
        const { doctorId, centerId} = this.props;
        const { documentType } = this.state;
        console.log(doctorId, centerId, documentType, 'HandleUPload');
        uploadDocument(doctorId, centerId, documentType, response.file, response.onProgress)
            .then((response) => {
                this.fetchDocs();
                this.setState({
                    documentType: '',
                });
                response.onSuccess(response, response.file);
            })
            .catch((err) => {
                response.onError(err);
            });
    };

    onChangeDocumentType = (value) => {
        this.setState({
            documentType: value,
        });
    };

    beforeUpload = () => {
        if (!this.state.documentType) {
            message.error('Please select a valid document type');
            throw new Error('Please select a valid document type');
        }
        return true;
    };

    render() {
        const { previewVisible, previewImage, fileList, previewTitle } = this.state;
        const { documentType } = this.state;
        return (
            <div className="clearfix">
                Document Type &nbsp;
                {this.props.centerId ? <Select
                    showSearch
                    style={{ width: 250 }}
                    placeholder="Select a Document Type"
                    optionFilterProp="children"
                    onChange={this.onChangeDocumentType}
                    value={documentType}
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    <Option value="Agreement - MOU">Agreement - MOU</Option>
                    <Option value="Agreement - Whatsapp">Agreement - Whatsapp</Option>
                    <Option value="Agreement - Mail">Agreement - Mail</Option>
                    <Option value="Payment Details - Cancelled Cheque">Payment Details - Cancelled Cheque</Option>
                    <Option value="Payment Details - UPI">Payment Details - UPI</Option>
                    {/* <Option value="Pan Card">Pan Card</Option> */}
                    <Option value="Certificate - TDS">Certificate - TDS</Option>
                    <Option value="Certificate - NABH">Certificate - NABH</Option>
                    <Option value="Certificate - NABL">Certificate - NABL</Option>
                </Select> : <Select
                    showSearch
                    style={{ width: 250 }}
                    placeholder="Select a Document Type"
                    optionFilterProp="children"
                    onChange={this.onChangeDocumentType}
                    value={documentType}
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    <Option value="CV">CV</Option>
                    <Option value="Qualification Certificate - UG">Qualification Certificate - UG</Option>
                    <Option value="Qualification Certificate - PG">Qualification Certificate - PG</Option>
                    <Option value="Registration Certificate">Registration Certificate</Option>
                    <Option value="Cancelled Cheque">Cancelled Cheque</Option>
                </Select>
                }
                &nbsp;
                <Upload
                    accept="image/*,application/pdf"
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onChange={this.handleChange}
                    onRemove={this.handleRemove}
                    beforeUpload={this.beforeUpload}
                    customRequest={this.handleUpload}
                >
                    <Button>
                        <Icon type="upload" /> Upload
                    </Button>
                </Upload>
                <Modal
                    visible={previewVisible}
                    title={previewTitle}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <iframe style={{ width: '100%', "minHeight": "500px" }} src={previewImage} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DocumentsScreen);
